export const ProductsData = [
  {
    id: "1",
    image: "assets/img/products/stock-img-01.png",
    SKU: "PT001",
    Product_Name: "Lenovo IdeaPad 3",
    Category: "Computers",
    Brand: "Lenovo",
    Price: "$600",
    Unit: "Pc",
    Qty: "100",
    Created_By: "James Kirwin",
    profile_image: "assets/img/users/user-30.jpg",
  },
  {
    id: "2",
    image: "assets/img/products/stock-img-06.png",
    SKU: "PT002",
    Product_Name: "Beats Pro",
    Category: "Electronics",
    Brand: "Beats",
    Price: "$160",
    Unit: "Pc",
    Qty: "140",
    Created_By: "Francis Chang",
    profile_image: "assets/img/users/user-13.jpg",
  },
  {
    id: "3",
    image: "assets/img/products/stock-img-02.png",
    SKU: "PT003",
    Product_Name: "Nike Jordan",
    Category: "Shoe",
    Brand: "Nike",
    Price: "$110",
    Unit: "Pc",
    Qty: "300",
    Created_By: "Antonio Engle",
    profile_image: "assets/img/users/user-11.jpg",
  },
  {
    id: "4",
    image: "assets/img/products/stock-img-03.png",
    SKU: "PT004",
    Product_Name: "Apple Series 5 Watch",
    Category: "Electronics",
    Brand: "Apple",
    Price: "$120",
    Unit: "Pc",
    Qty: "450",
    Created_By: "Leo Kelly",
    profile_image: "assets/img/users/user-32.jpg",
  },
  {
    id: "5",
    image: "assets/img/products/stock-img-04.png",
    SKU: "PT005",
    Product_Name: "Amazon Echo Dot",
    Category: "Electronics",
    Brand: "Amazon",
    Price: "$80",
    Unit: "Pc",
    Qty: "320",
    Created_By: "Annette Walker",
    profile_image: "assets/img/users/user-02.jpg",
  },
  {
    id: "6",
    image: "assets/img/products/stock-img-05.png",
    SKU: "PT006",
    Product_Name: "Sanford Chair Sofa",
    Category: "Furnitures",
    Brand: "Modern Wave",
    Price: "$320",
    Unit: "Pc",
    Qty: "650",
    Created_By: "John Weaver",
    profile_image: "assets/img/users/user-05.jpg",
  },
  {
    id: "7",
    image: "assets/img/products/expire-product-01.png",
    SKU: "PT007",
    Product_Name: "Red Premium Satchel",
    Category: "Bags",
    Brand: "Dior",
    Price: "$60",
    Unit: "Pc",
    Qty: "700",
    Created_By: "Gary Hennessy",
    profile_image: "assets/img/users/user-08.jpg",
  },
  {
    id: "8",
    image: "assets/img/products/expire-product-02.png",
    SKU: "PT008",
    Product_Name: "Iphone 14 Pro",
    Category: "Phone",
    Brand: "Apple",
    Price: "$540",
    Unit: "Pc",
    Qty: "630",
    Created_By: "Eleanor Panek",
    profile_image: "assets/img/users/user-04.jpg",
  },
  {
    id: "9",
    image: "assets/img/products/expire-product-03.png",
    SKU: "PT009",
    Product_Name: "Gaming Chair",
    Category: "Furniture",
    Brand: "Arlime",
    Price: "$200",
    Unit: "Pc",
    Qty: "410",
    Created_By: "William Levy",
    profile_image: "assets/img/users/user-09.jpg",
  },
  {
    id: "10",
    image: "assets/img/products/expire-product-04.png",
    SKU: "PT010",
    Product_Name: "Borealis Backpack",
    Category: "Bags",
    Brand: "The North Face",
    Price: "$45",
    Unit: "Pc",
    Qty: "550",
    Created_By: "Charlotte Klotz",
    profile_image: "assets/img/users/user-10.jpg",
  },
  {
    id: "11",
    image: "assets/img/products/expire-product-04.png",
    SKU: "PT010",
    Product_Name: "Borealis Backpack",
    Category: "Bags",
    Brand: "The North Face",
    Price: "$45",
    Unit: "Pc",
    Qty: "550",
    Created_By: "Charlotte Klotz",
    profile_image: "assets/img/users/user-10.jpg",
  },
];
